export const paramToString = (data = {}) => Object.entries(data)
    .reduce((queryString, [key, value = '']) =>
            (queryString ? `${queryString}&` : '') + `${key}=${value ? value.toString() : ''}`,
        '')


// https://cdn.lexus.areyeshot.com/uploads/car-model/newWeb/officialwebsite/template.html#rz
// const iframe_360 = document.getElementById('iframe_360');
// const mWin =iframe_360 ? (iframe_360.window || iframe_360.contentWindow) : window;
// console.log(JSON.stringify({
//     ratio: Math.floor(Math.max(window.innerWidth / window.innerHeight, window.innerHeight / window.innerWidth) * 10000) / 10000,
//     camera: mWin.appInstance.camera.position.toArray()
// }, null, 4))
export const getCameraConfig = () => {
    const aspectRatio = [
        {
            "ratio": 1.1274,
            "camera": [
                -0.4066791418010104,
                1.9344532254849527,
                4.830298417930657
            ]
        },
        {
            "ratio": 0.5948,
            "camera": [
                -0.370920258889617,
                0.5983789604163711,
                3.759763765076533
            ]
        },
        {
            "ratio": 0.3638,
            "camera": [
                0.06410304898221028,
                0.5408029678487298,
                3.4138937755275847
            ]
        },
        {
            "ratio": 1.5289,
            "camera": [
                0.225505759996582,
                1.6717990003373076,
                7.820117342769175
            ]
        },
        {
            "ratio": 0.3292,
            "camera": [
                -0.06313965106709561,
                1.359838235320722,
                2.933011713149037
            ]
        },
        {
            "ratio": 0.3152,
            "camera": [
                -0.05153757893916722,
                0.6069481125044873,
                3.1637581489701843
            ]
        },
        {
            "ratio": 0.0659,
            "camera": [
                -0.056343499797453594,
                1.174618861004,
                2.359309979124787
            ]
        },
        {
            "ratio": 0.8859,
            "camera": [
                -0.061072091205252164,
                0.777952689953324,
                4.911420282316559
            ]
        },
        {
            "ratio": 0.6003,
            "camera": [
                -0.4323694483093948,
                0.6549092707649151,
                3.743743219712188
            ]
        }

    ]
    const width = window.innerWidth
    const height = document.querySelector('.b-content').getBoundingClientRect().top - document.querySelector('.select-car').getBoundingClientRect().bottom
    const ratio = (height / width).toFixed(4)
    const aspectItem = aspectRatio.sort((a, b) => b.ratio - a.ratio).find(r => ratio === 1 ? r.ratio <= ratio : ratio > r.ratio) || {}

    return []||aspectItem?.camera || []
}

// const iframe_360 = document.getElementById('iframe_360');
// const mWin = iframe_360 ? (iframe_360.window || iframe_360.contentWindow) : window;
// const width = window.innerWidth
// const height = document.querySelector('.b-content').getBoundingClientRect().top - document.querySelector('.select-car').getBoundingClientRect().bottom
// const ratio = (height / width)
// console.log(JSON.stringify({
//     ratio: Math.floor(ratio * 10000) / 10000,
//     camera: mWin.appInstance.camera.position.toArray()
// }, null, 4))